import React, {useRef} from "react";
import {
    IonButton,
    IonContent,
    IonHeader, IonIcon,
    IonPage,
    IonTitle,
    IonToolbar
} from "@ionic/react";
import './ModalImage.css';
import {cloudDownloadOutline, cloudDownloadSharp} from "ionicons/icons";

const ModalImage = ({dismiss, imageUrl}: { dismiss: (data?: string | null | undefined | number, role?: string) => void, imageUrl: string}) => {


    const modal = useRef<HTMLIonModalElement>(null);
    const downloadImage = async (imageSrc: string) => {
        // Create an invisible link element
        const a = document.createElement('a');
        a.href = imageSrc;
        a.download = '';  // Browser will automatically infer the filename
        a.style.display = 'none';

        // Append the link to the document, trigger click, then remove the link
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    return (
        <IonPage ref={modal}>
            <IonHeader>
                <IonToolbar>

                    <IonTitle>Image Viewer</IonTitle>

                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <div style={{textAlign: 'center'}}>
                    <img style={{border: '1px solid black'}} id="myimage" src={imageUrl} />
                    <br />
                    <IonButton fill="outline" onClick={() => downloadImage(imageUrl)}><IonIcon md={cloudDownloadOutline} ios={cloudDownloadSharp}></IonIcon> &nbsp;Download Image</IonButton>
                </div>
                <p style={{textAlign: 'right'}}>
                    <IonButton fill="solid" strong={true} onClick={() => dismiss()}>
                        Close
                    </IonButton>
                </p>
            </IonContent>
        </IonPage>);
};

export default ModalImage